export const easing = {enter: "cubic-bezier(0.25, 1, 0.5, 1)"};